import { motion } from "framer-motion";
import { GALLERY } from "@/lib/data";
import Reveal from "@/components/site/Reveal";

export default function Gallery() {
  return (
    <section id="gallery" className="relative py-24 md:py-40 bg-[#140A0D] border-y border-[#D4AF37]/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
            <div>
              <p className="font-body text-xs tracking-[0.4em] uppercase text-[#D4AF37] mb-4">Feast for the Eyes</p>
              <h2 className="font-display text-4xl sm:text-6xl lg:text-7xl text-[#FDFBF7] leading-[0.95]">
                The <span className="gold-gradient-text italic">Gallery</span>
              </h2>
            </div>
          </div>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] md:auto-rows-[240px] gap-3 md:gap-4">
          {GALLERY.map((g, i) => (
            <motion.div
              key={i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: (i % 4) * 0.06 }}
              className={`group relative overflow-hidden ${g.span}`}
            >
              <img
                src={g.img}
                alt={g.label}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-[900ms] ease-out"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0607]/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <span className="absolute bottom-4 left-4 font-display text-xl text-[#FDFBF7] opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500">
                {g.label}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
